/* Pointer-only visual enhancement: no network requests or commerce changes. */
(() => {
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let active, frame = 0, pending;
  const enabled = () => fine.matches && !reduced.matches && document.body.dataset.boxzyMotion !== 'false' && !document.body.classList.contains('low-motion') && !document.body.classList.contains('boxzy-motion-off');
  function reset() {
    cancelAnimationFrame(frame); frame = 0; pending = null;
    if (active) ['--showcase-tilt-x','--showcase-tilt-y','--showcase-light-x','--showcase-light-y'].forEach(key => active.style.removeProperty(key));
    active = null;
  }
  document.addEventListener('pointermove', event => {
    if (!enabled() || event.pointerType === 'touch') { reset(); return; }
    const scene = event.target.closest('.product-card__media')?.querySelector('[data-product-showcase]');
    if (!scene) { reset(); return; }
    if (active !== scene) { reset(); active = scene; }
    pending = {x:event.clientX,y:event.clientY};
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      if (!active?.isConnected || !pending || !enabled()) { reset(); return; }
      const rect = active.getBoundingClientRect();
      const x = Math.max(0,Math.min(1,(pending.x-rect.left)/rect.width));
      const y = Math.max(0,Math.min(1,(pending.y-rect.top)/rect.height));
      active.style.setProperty('--showcase-tilt-x',`${(0.5-y)*3}deg`);
      active.style.setProperty('--showcase-tilt-y',`${(x-0.5)*4}deg`);
      active.style.setProperty('--showcase-light-x',`${35+x*30}%`);
      active.style.setProperty('--showcase-light-y',`${35+y*20}%`);
    });
  },{passive:true});
  document.addEventListener('pointerout',event => { if (active && !active.closest('.product-card__media')?.contains(event.relatedTarget)) reset(); },{passive:true});
  document.addEventListener('visibilitychange',() => {if(document.hidden)reset();});
  window.addEventListener('blur',reset);
  window.addEventListener('scroll',reset,{passive:true});
  fine.addEventListener('change',reset);reduced.addEventListener('change',reset);
  document.addEventListener('shopify:section:unload',reset);
})();
